import React from 'react'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const UserProfileForm = React.lazy(() => loadComponent('orga', 'UserProfileForm'))

export function ProfileRoute() {
    return (
        <RouteContainer>
            <UserProfileForm />
        </RouteContainer>
    )
}
